import { Component, OnInit, Input, Output, EventEmitter, HostListener, SimpleChanges, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { BookingParametersInterface } from '../../../../../src/app/shared/entities/bookingParameters';
import { ResolutionService } from '../../../../../src/app/core/services/resolution.service';

@Component({
  selector: 'app-search-widget',
  templateUrl: './search-widget.component.html',
  styleUrls: ['./search-widget.component.scss']
})
export class SearchWidgetComponent implements OnInit, OnChanges {

  /**
   * the display language
   */
  @Input() lang: string;

  /**
   * set the initial booking parameters. default are undefined and will be set dynamically
   */
  @Input() bookingParameters: BookingParametersInterface = undefined;

  @Input() maxAllowedChildren: number = undefined;

  @Input() maxAllowedPersons = 50;

  /**
   * enable or disable the logo. default: true
   */
  @Input() showLogo = true;

  /**
   * enable or disable the promocode field. default: false
   */
  @Input() hidePromocode = false;

  @Input() refererId: string;

  @Input() alwaysReportSearches = false;

  /**
   * disable the search input
   */
  @Input() disableSearch = false;

  @Output() sentForm = new EventEmitter<BookingParametersInterface>();

  constructor(
    private translateService: TranslateService,
    private resolutionService: ResolutionService,
    private localizeRouterService: LocalizeRouterService) {
  }

  ngOnInit() {
    this.localizeRouterService.changeLanguage(this.lang);
    this.translateService.use(this.lang);
    this.translateService.setDefaultLang(this.lang);
  }

  /**
   * allows incoming changes to be correctly reflected in the component
   * @param changes the input value changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['lang']) {
      this.localizeRouterService.changeLanguage(changes['lang'].currentValue);
      this.translateService.use(changes['lang'].currentValue);
      this.translateService.setDefaultLang(changes['lang'].currentValue);
    }
  }

  updateForm($event: BookingParametersInterface) {
    this.sentForm.emit($event);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.resolutionService.updateSizeReference(document.body.clientWidth);
  }

}
